import HttpResponse from "../../../../../utils/http/http.response";

export enum TaxiCorporationDriverPlanResponseDataPlanEntryViewType {
  RESTRICTED = "RESTRICTED",
  FULL = "FULL",
}

export type TaxiCorporationDriverPlanResponseDataRestrictedPlanEntryEndNodeMeta =
  {
    estimatedTime: string;
    id: string;
  };

export type TaxiCorporationDriverPlanResponseDataRestrictedPlanEntryEndNode = {
  displayName: string;
  lat: number;
  lon: number;
  time: string | null;
  haltingTime: number | null;
  meta: TaxiCorporationDriverPlanResponseDataRestrictedPlanEntryEndNodeMeta;
};

export type TaxiCorporationDriverPlanResponseDataRestrictedPlanEntryStartNodeMeta =
  {
    estimatedTime: string;
    id: string;
  };

export type TaxiCorporationDriverPlanResponseDataRestrictedPlanEntryStartNode =
  {
    displayName: string;
    lat: number;
    lon: number;
    time: string | null;
    haltingTime: number | null;
    meta: TaxiCorporationDriverPlanResponseDataRestrictedPlanEntryStartNodeMeta;
  };

export type TaxiCorporationDriverPlanResponseDataRestrictedPlanEntry = {
  id: string;
  humanId: number;
  viewType: TaxiCorporationDriverPlanResponseDataPlanEntryViewType.RESTRICTED;
  startNode: TaxiCorporationDriverPlanResponseDataRestrictedPlanEntryStartNode;
  endNode: TaxiCorporationDriverPlanResponseDataRestrictedPlanEntryEndNode;
};

export type TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersRideSeqMeta =
  {
    estimatedTime: string;
    id: string;
  };

export type TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersRideSeq =
  {
    displayName: string;
    lat: number;
    lon: number;
    time: string | null;
    haltingTime: number | null;
    meta: TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersRideSeqMeta;
  };

export type TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersRide =
  {
    seq: TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersRideSeq[];
  };

export type TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersTransportingOrderCargoOrder =
  {
    id: string;
    humanId: number;
  };

export type TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersTransportingOrder =
  {
    cargoOrder: TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersTransportingOrderCargoOrder;
  };

export type TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrders = {
  id: string;
  ride: TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersRide;
  transportingOrder: TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrdersTransportingOrder;
};

export type TaxiCorporationDriverPlanResponseDataFullPlanEntryNodeExclusion = {
  excludeApproaching: boolean;
  excludeInside: boolean;
  excludeReturning: boolean;
  nodeIds: string[];
};

export type TaxiCorporationDriverPlanResponseDataFullPlanEntryNodeExclusions = {
  exclusions: TaxiCorporationDriverPlanResponseDataFullPlanEntryNodeExclusion[];
};

export type TaxiCorporationDriverPlanResponseDataFullPlanEntryEndNodeMeta = {
  estimatedTime: string;
  id: string;
};

export type TaxiCorporationDriverPlanResponseDataFullPlanEntryEndNode = {
  displayName: string;
  lat: number;
  lon: number;
  time: string | null;
  haltingTime: number | null;
  meta: TaxiCorporationDriverPlanResponseDataFullPlanEntryEndNodeMeta;
};

export type TaxiCorporationDriverPlanResponseDataFullPlanEntryStartNodeMeta = {
  estimatedTime: string;
  id: string;
};

export type TaxiCorporationDriverPlanResponseDataFullPlanEntryStartNode = {
  displayName: string;
  lat: number;
  lon: number;
  time: string | null;
  haltingTime: number | null;
  meta: TaxiCorporationDriverPlanResponseDataFullPlanEntryStartNodeMeta;
};

export type TaxiCorporationDriverPlanResponseDataFullPlanEntryCheckoutEvent = {
  id: string;
  nodeId: string;
  achievedAt: string;
  haltingTime: number | null;
  highwayCharge: number;
  createdAt: Date | null;
  createdByName: string | null;
};

export type TaxiCorporationDriverPlanResponseDataFullPlanEntry = {
  id: string;
  humanId: number;
  viewType: TaxiCorporationDriverPlanResponseDataPlanEntryViewType.FULL;
  checkoutEvents: TaxiCorporationDriverPlanResponseDataFullPlanEntryCheckoutEvent[];
  startNode: TaxiCorporationDriverPlanResponseDataFullPlanEntryStartNode;
  endNode: TaxiCorporationDriverPlanResponseDataFullPlanEntryEndNode;
  solvedOrders: TaxiCorporationDriverPlanResponseDataFullPlanEntrySolvedOrders[];
  nodeExclusions: TaxiCorporationDriverPlanResponseDataFullPlanEntryNodeExclusions;
};

export type TaxiCorporationDriverPlanResponseDataPlanEntry =
  | TaxiCorporationDriverPlanResponseDataRestrictedPlanEntry
  | TaxiCorporationDriverPlanResponseDataFullPlanEntry;

export type TaxiCorporationDriverPlanResponseData = {
  entries: TaxiCorporationDriverPlanResponseDataPlanEntry[];
};

type TaxiCorporationDriverPlanResponse =
  HttpResponse<TaxiCorporationDriverPlanResponseData>;

export default TaxiCorporationDriverPlanResponse;
